import { RouteRecordRaw } from 'vue-router';

export const labsRouteConfig: RouteRecordRaw = {
  name: 'labs',
  path: '/labs',
  component: () => import('@/components/labs/main.vue'),
  meta: {
    title: '調査AIエージェント | Stockmark Labs',
    accessScope: 'information_retrieval',
  },
  children: [
    {
      path: '/labs/',
      component: () => import('@/components/labs/top/index.vue'),
      meta: { title: 'Labs トップ | Stockmark Labs' },
      name: 'labsHome',
    },
    {
      path: '/labs/reports/templates/network-graph',
      name: 'networkGraph',
      redirect: () => {
        return `/labs/reports/templates/network-graph/member`;
      },
    },
    {
      path: '/labs/reports/templates/network-graph/member',
      meta: {
        title: 'ネットワークグラフ・メンバー | Stockmark Labs',
      },
      component: () =>
        import('@/components/labs/reports/templates/network-graph.vue'),
      name: 'networkGraphMember',
    },
    {
      path: '/labs/reports/templates/network-graph/organization-tags',
      meta: {
        title: 'ネットワークグラフ・組織タグ | Stockmark Labs',
      },
      component: () =>
        import(
          '@/components/labs/reports/templates/network-graph-organization-tags.vue'
        ),
      name: 'networkGraphOrganizationTags',
    },
    {
      path: '/labs/reports/templates/trending-topics',
      meta: { title: '注目トピック分析 | Stockmark Labs' },
      component: () =>
        import('@/components/labs/reports/templates/trending-topics.vue'),
      name: 'trendingTopics',
    },
  ],
};
